import CLAP from './sounds/clap.wav';
import HAT from './sounds/hat.wav';
import FX from './sounds/fx.wav';
import KICK from './sounds/kick.wav';
import SNARL from './sounds/snarl.wav';
import TOM from './sounds/tom.wav';
import FLAM from './sounds/flam.wav';
import RIM from './sounds/rim.wav';
import CRASH from './sounds/crash.wav';

const NAMES = {
    CLAP:'CLAP',
    HAT:'HAT',
    FX:'FX',
    KICK:'KICK',
    SNARL:'SNARL',
    TOM:'TOM',
    FLAM:'FLAM',
    RIM:'RIM',
    CRASH:'CRASH'
};

const SOUNDS = [{
    key:CLAP,
    name:NAMES.CLAP
},{
    key:HAT,
    name:NAMES.HAT
},{
    key:FX,
    name:NAMES.FX
},{
    key:KICK,
    name:NAMES.KICK
},{
    key:SNARL,
    name:NAMES.SNARL
},{
    key:TOM,
    name:NAMES.TOM
},{
    key:FLAM,
    name:NAMES.FLAM
},{
    key:RIM,
    name:NAMES.RIM
},{
    key:CRASH,
    name:NAMES.CRASH
}];

export default SOUNDS;